import WithdrawCashContainer from 'containers/withdrawCash';

export default {
  exact: true,
  name: 'withdraw-cash',
  protected: true,
  path: '/withdraw-cash',
  component: WithdrawCashContainer,
};
